import React from "react";
import styles from "./blueprint-banner-flex-wrapper.module.scss";

const cssClassName = "blueprint-banner-flex-wrapper";

interface BlueprintBannerFlexWrapperTypes {
  children: React.ReactNode;
}

export const BlueprintBannerFlexWrapper = ({
  children,
}: BlueprintBannerFlexWrapperTypes) => {
  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__inner-wrapper`]}>{children}</div>
    </div>
  );
};
